const creditCoinUrl = "/images/credit-coin.webp";

const CreditIcon = ({ className = "w-4 h-4", inline = false }: { className?: string; inline?: boolean }) => (
  <img
    src={creditCoinUrl}
    alt="C"
    className={`${className} ${inline ? 'inline-block align-middle' : ''} object-contain`}
    style={{ filter: 'drop-shadow(0 0 4px hsl(174 90% 50% / 0.5))' }}
  />
);

/** Format a number with the credit symbol as a React element */
export const CreditPrice = ({ amount, className = "" }: { amount: number | string; className?: string }) => {
  const num = typeof amount === "string" ? parseFloat(amount.replace(/[^\d.]/g, "")) : amount;
  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`}>
      <CreditIcon className="w-4 h-4" inline />
      <span>{isNaN(num) ? amount : num.toFixed(2)}</span>
    </span>
  );
};

/** Parse a price string like "₪50.00" and return just the number */
export const parsePriceNumber = (price: string): number => {
  return parseFloat(price.replace(/[^\d.]/g, "")) || 0;
};

export default CreditIcon;
